import axioPath from '../../../api/axioPath';
import { UPDATE_DATA } from 'redux/actions/action_types'
import { showAppLoader, hideAppLoader } from '../app';
// import _ from 'lodash';

export const inventoryBidWithdraw = (data, token) => (dispatch) => {
    dispatch(showAppLoader());
    return axioPath
        .post('/rfp/postInventory/bid/withdraw', data, {
            headers: {
                Authorization: `${token}`,
            },
        })
        .then((response) => {
            setTimeout(
                () => {
                    dispatch(hideAppLoader());
                },
                3000
            );
            dispatch({ type: UPDATE_DATA, payload: response.data });
            return response.data;
        })
        .catch((ex) => {
            dispatch(hideAppLoader());
            return ex;
        });
};
export const inventoryBuyNowWithdraw = (data, token) => (dispatch) => {
    dispatch(showAppLoader());
    return axioPath
        .post('/rfp/postInventoryBuyNow/withdraw', data, {
            headers: {
                Authorization: `${token}`,
            },
        })
        .then((response) => {
            setTimeout(
                () => {
                    dispatch(hideAppLoader());
                },
                3000
            );
            dispatch({ type: UPDATE_DATA, payload: response.data });
            return response.data;
        })
        .catch((ex) => {
            dispatch(hideAppLoader());
            return ex;
        });
};
export const inventoryBuyNowCpuWithdraw = (data, token) => (dispatch) => {
    dispatch(showAppLoader());
    return axioPath
        .post('/rfp/postInventoryBuyNowCpu/withdraw', data, {
            headers: {
                Authorization: `${token}`,
            },
        })
        .then((response) => {
            setTimeout(
                () => {
                    dispatch(hideAppLoader());
                },
                3000
            );
            dispatch({ type: UPDATE_DATA, payload: response.data });
            return response.data;
        })
        .catch((ex) => {
            dispatch(hideAppLoader());
            return ex;
        });
};
export const inventoryOfferWithdraw = (data, token) => (dispatch) => {
    dispatch(showAppLoader());
    return axioPath
        .post('/rfp/postInventoryOffer/withdraw', data, {
            headers: {
                Authorization: `${token}`,
            },
        })
        .then((response) => {
            setTimeout(
                () => {
                    dispatch(hideAppLoader());
                },
                3000
            );
            dispatch({ type: UPDATE_DATA, payload: response.data });
            return response.data;
        })
        .catch((ex) => {
            dispatch(hideAppLoader());
            return ex;
        });
};
export const postLoadOfferWithdraw = (data, token) => (dispatch) => {
    dispatch(showAppLoader());
    return axioPath
        .post('/rfp/postLoadOffer/withdraw', data, {
            headers: {
                Authorization: `${token}`,
            },
        })
        .then((response) => {
            setTimeout(
                () => {
                    dispatch(hideAppLoader());
                },
                3000
            );
            dispatch({ type: UPDATE_DATA, payload: response.data });
            return response.data;
        })
        .catch((ex) => {
            dispatch(hideAppLoader());
            return ex;
        });
};
export const postLoadBidWithdraw = (data, token) => (dispatch) => {
    dispatch(showAppLoader());
    return axioPath
        .post('/rfp/postLoad/bid/withdraw', data, {
            headers: {
                Authorization: `${token}`,
            },
        })
        .then((response) => {
            setTimeout(
                () => {
                    dispatch(hideAppLoader());
                },
                3000
            );
            dispatch({ type: UPDATE_DATA, payload: response.data });
            return response.data;
        })
        .catch((ex) => {
            dispatch(hideAppLoader());
            if (ex.response) return { error: true, data: ex.response?.data };
            else return ex;
        });
};
export const postLoadV2BidWithdraw = (data, token) => (dispatch) => {
    dispatch(showAppLoader());
    return axioPath
        .post('/rfp/v2/need/bid_withdraw', data, {
            headers: {
                Authorization: `${token}`,
            },
        })
        .then((response) => {
            setTimeout(
                () => {
                    dispatch(hideAppLoader());
                },
                3000
            );
            dispatch({ type: UPDATE_DATA, payload: response.data });
            return response.data;
        })
        .catch((ex) => {
            dispatch(hideAppLoader());
            if (ex.response) return { error: true, data: ex.response?.data, statusCode: ex.response?.status };
            else return ex;
        });
};

export const offerInvWithdrawApi = (data, token) => (dispatch) => {
    dispatch(showAppLoader());
    return axioPath
        .post('/rfp/v2/inventory/offer_withdraw', data, {
            headers: {
                Authorization: `${token}`,
            },
        })
        .then((response) => {
            dispatch(hideAppLoader());
            return response.data;
        })
        .catch((ex) => {
            dispatch(hideAppLoader());
            if (ex.response) return { error: true, data: ex.response?.data, statusCode: ex.response?.status };
            else return ex;
        });
};
